declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SaveFollicularScanOvaryDetailRequest, SaveIvfCycleTestDataRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';

@Component({
  selector: 'ngbaddtestpickup',
  templateUrl: './addpickuptest.modal.html',
  styleUrls: ['./addpickuptest.modal.scss']
})

export class NgbAddPickUpTestModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() IsShowDetail: boolean = false;
  //@Input() CurrentSaveFollicularScanOvaryDetailRequest: SaveFollicularScanOvaryDetailRequest;
 
  @Input() ActivityCode: number;
  @Input() CycleCode: number;
  @Input() ActorCode1: number;
  @Input() TestCode1: number;
  @Input() ClinicalOrderItem: number;
  searchTitle: string;
  public ApiResData: ApiResponseModel;
  StartDate: NgbDateStruct;
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  CurrentSaveIvfCycleTestDataRequest: SaveIvfCycleTestDataRequest;
  //public IsSelected: boolean;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
    private tosterservice: NGXToastrService) { }
  ActorCode: number;
  //TestCode: number;
  ngOnInit() {
    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    //this.TestCode = 823;
    //alert(this.ActorCode);
    this.ShowService = false;
    //alert(this.CycleCode);

    //this.LoadRegistries();
    this.CurrentSaveIvfCycleTestDataRequest = new SaveIvfCycleTestDataRequest();
    this.CurrentSaveIvfCycleTestDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }




  



  onSubmit() {

    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
    this.CurrentSaveIvfCycleTestDataRequest.ConditionalOperator = 10;
    this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.ActivityCode;
    this.CurrentSaveIvfCycleTestDataRequest.CycleCode = this.CycleCode;
    this.CurrentSaveIvfCycleTestDataRequest.ClinicalOrderItem = this.ClinicalOrderItem;
    //alert(this.CurrentSaveIvfCycleTestDataRequest.CycleCode);
    this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.ActorCode1;
    //this.CurrentSaveIvfCycleTestDataRequest.CycleCode = 0;
    this.CurrentSaveIvfCycleTestDataRequest.CycleTestCode = 0;
    //this.CurrentSaveIvfCycleTestDataRequest.TestCode = this.TestCode1;
    this.CurrentSaveIvfCycleTestDataRequest.TestObservation = 0;
    this.CurrentSaveIvfCycleTestDataRequest.TestDate = new Date();
    this.actorservice.SaveIvfCycleTestData(this.CurrentSaveIvfCycleTestDataRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          
          if (this.ApiResData.Result > 0) {
            this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  //onAssignedToActorCode(event: any) {

  //  if (event != null) {
  //      }
  //  }

  onAssignedToActorCode(event: any) {

    if (event != null) {
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      this.CurrentSaveIvfCycleTestDataRequest.TestCode = event;
      this.CurrentSaveIvfCycleTestDataRequest.TestName = event;
      // console.log('event--_>' + event);
      //   }
    }

  }



}
